import { render, staticRenderFns } from "./MedicineAnalog.vue?vue&type=template&id=b31a9650"
import script from "./MedicineAnalog.vue?vue&type=script&lang=js"
export * from "./MedicineAnalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports